export default {
    recipes: {
        metaTitle: 'Athlisis - Συνταγή',
        empty: {
            title: 'Δεν βρέθηκε η συνταγή',
            subtitle: 'Έχετε εισάγει λάθος σύνδεσμο, ή η συνταγή αυτή δεν είναι πλέον διαθέσιμη.'
        },
        recipe: 'Συνταγή',
        nutritionLabel: 'Διατροφική Ετικέτα'
    },
    questionnaire: {
        saved: {
            title: 'Οι απαντήσεις σας αποθηκεύτηκαν!',
            text: 'Οι απαντήσεις σας είναι πλέον διαθέσιμες. Δεν χρειάζεται να κάνετε κάποια περαιτέρω ενέργεια. Μπορείτε να κλείσετε αυτή τη σελίδα ή να χρησιμοποιήσετε τον ίδιο σύνδεσμο οποιαδήποτε στιγμή για να ενημερώσετε τις απαντήσεις σας.',
            editAgain: 'Επεξεργασία απαντήσεων'
        }
    },
    couponUse: {
        title: 'Πληκτρολογήστε το κουπόνι σας και τον κωδικό σας για να δείτε το ιστορικό συναλλαγών.',
        code: 'Κωδ. Κουπονιού',
        password: 'Κωδ. πρόσβασης',
        view: 'Προβολή συναλλαγών',
        back: 'Επιστροφή στην εισαγωγή κουπονιού',
        placeholder: {
            code: 'Ο κωδικός κουπονιού σας',
            password: 'Ο κωδ. πρόσβασής σας'
        }
    }
}